// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"V4-z"};